var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Welcome to the Forum")]),_c('CategoryList',{attrs:{"categories":_vm.categories}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }